import React, { useEffect } from 'react';
import { TextAppearance } from '@vw-marketing/us-components';

import { useAccountSettingsLayers } from './layer-manager/useAccountSettingsLayers';
import { useAccountSettings } from './hooks/useAccountSettings';
import { useTrackingManager } from '../../shared/hooks/use-tracking-manager';
import { onVWBasicStepLoadEvent } from '../../shared/tagging/tagging-helpers';
import PageContainer from '../../shared/components/page-container';
import TabsContent from '../../shared/components/tabs-content';

export const AccountSettings: React.FC = () => {
  const {
    active,
    changes,
    content,
    editEmailModal,
    goBack,
    isDeactivating,
    items,
    noTranslateTerms,
    setActive,
    setEditEmailModal,
    title,
  } = useAccountSettings();

  const trackingManager = useTrackingManager();

  useAccountSettingsLayers({
    editActive: active,
    editTitle: title,
    editNoTranslateTerms: noTranslateTerms,
    editContent: content,
    editIsDeactivating: isDeactivating,
    editChanges: changes,
    editGoBack: goBack,
    onEditClose: () => { setActive(false); },
    emailActive: editEmailModal,
    onEmailClose: () => { setEditEmailModal(false); },
  });

  // Track page load event when component mounts
  useEffect(() => {
    try {
      // Call VWBasic_Step_Load event when account settings page loads
      onVWBasicStepLoadEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: 'Personal Information and Security',
        StepNumber: '4',
      });
    } catch (error) {
      console.warn('Error tracking account settings page load:', error);
    }
  }, [trackingManager]);

  return (
    <PageContainer labelKey="accountSettings" textAppearance={TextAppearance.headline400}>
      <TabsContent items={[...items]} />
    </PageContainer>
  );
};